// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonDelete_wrap__N+nkb"};